module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"corruptSelection":"The selection was reset."},"de":{"corruptSelection":"Die Auswahl wurde zurückgesetzt."},"fr":{"corruptSelection":"La sélection est supprimée."},"it":{"corruptSelection":"La selezione è stata eliminata."}}')
  delete Component.options._Ctor
}
